import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  .container {
    margin-bottom: 20px;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .justify-space-between {
    justify-content: space-between;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .col {
    display: flex;
    flex-direction: column;
  }

  .title-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: no-wrap;
    justify-content: space-between;
  }

  .block-title {
    margin-bottom: 0;
    margin-left: 20px;
    margin-right: 5px;
  }

  .approved-icon {
    width: 22px;
    height: 22px;
    margin-left: -15px;
    margin-top: -30px;
  }

  .save-wrapper {
    margin-top: 22px;
  }

  .close-btn {
    margin-right: 10px;
  }

  @media (max-width: ${Breakpoints.maxExtraSmall}) {
    .title-row {
      flex-wrap: wrap;
    }
    .title-col {
      margin-top: 10px;
      width: 100%;
      align-items: center;
    }
  }
`;
